export const ingredientsTribunal = [
    {
        name: 'Adamantium Ore',
        effects: ['Burden', 'Restore Magicka', 'Poison', 'Reflect'],
        value: 300,
        weight: 50.0
    },
    {
        name: 'Durzog Meat',
        effects: [
            'Fortify Agility',
            'Fortify Strength',
            'Blind',
            'Damage Magicka'
        ],
        value: 7,
        weight: 2.0
    },
    {
        name: 'Golden Sedge Flowers',
        effects: [
            'Drain Magicka',
            'Fortify Strength',
            'Fortify Attack',
            'Swift Swim'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Horn Lily Bulb',
        effects: [
            'Resist Paralysis',
            'Drain Health',
            'Restore Strength',
            'Restore Endurance'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Lloramor Spines',
        effects: [
            'Spell Absorption',
            'Invisibility',
            'Poison',
            'Detect Enchantment'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Meadow Rye',
        effects: [
            'Fortify Speed',
            'Damage Health',
            'Restore Speed',
            'Drain Speed'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Nirthfly Stalks',
        effects: [
            'Damage Health',
            'Fortify Speed',
            'Restore Speed',
            'Drain Speed'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Noble Sedge Flowers',
        effects: ['Damage Health', 'Restore Agility', 'Poison', 'Fortify Agility'],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Scrib Cabbage',
        effects: [
            'Drain Intelligence',
            'Damage Health',
            'Restore Agility',
            'Fortify Agility'
        ],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Sweetpulp',
        effects: ['Paralyze', 'Levitate', 'Resist Paralysis', 'Restore Health'],
        value: 1,
        weight: 1.0
    },
    {
        name: 'Timsa Come By Flowers',
        effects: [
            'Dispel',
            'Resist Paralysis',
            'Drain Magicka',
            'Restore Endurance'
        ],
        value: 1,
        weight: 1.0
    }
].map(it => ({
    ...it,
    isTribunal: true
}));
